angular.module('Itao.IndicatorMap').service('DistrictStyling', function (mapConfig) {
  'use strict';
  return {

    /**
     * Returns the ol styling object for a given indicator and value
     * uses the configurable styles from the mapConfig
     * hover style is applied on top of selected style
     *
     * @param {Indicator} indicator the indicator to use
     * @param {float} value the value of the district
     * @param {float} fillOpacity configurable opacity for the fill color
     * @param {boolean} selected apply selected style
     * @param {boolean} hover apply hover style
     *
     * @returns {object}
     */
    getStyleForIndicatorAndValue: function (indicator, value, fillOpacity, selected, hover) {
      var styling = angular.copy(mapConfig.styling.default);
      if(angular.isNumber(fillOpacity)) {
        styling.fillOpacity = fillOpacity;
      }
      if(selected === true) {
        for(var selectedProperty in mapConfig.styling.selected) {
          styling[selectedProperty] = mapConfig.styling.selected[selectedProperty];
        }
      }
      if(hover === true) {
        for(var hoverProperty in mapConfig.styling.hover) {
          styling[hoverProperty] = mapConfig.styling.hover[hoverProperty];
        }
      }
      styling.fillColor = indicator ? indicator.getColorForValue(value) : selected ? mapConfig.styling.selected.fillColor : mapConfig.styling.default.fillColor;
      return styling;
    }
  };
});
